var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBatteryChargingPercent80 = function SvgIconBatteryChargingPercent80(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#232D35",
    fillRule: "evenodd",
    d: "M14.347 12.058a.36.36 0 0 0-.252-.24l-2.46-.659 1.036-3.866a.364.364 0 0 0-.635-.323L7.53 12.543a.363.363 0 0 0 .189.58l2.46.66-1.036 3.867a.364.364 0 0 0 .635.323l4.507-5.574a.36.36 0 0 0 .063-.341M8.7 16.999l-.2.9H4c-1.1 0-2-.9-2-2v-6.9c0-1.1.9-2 2-2h7.2l-.8 1H4c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1zm8.6-10h-4.126l-.174 1h4.3c.6 0 1 .4 1 1v6.9c0 .6-.4 1-1 1h-6.1l-.8 1h6.9c1.1 0 2-.9 2-2v-6.9c0-1.1-.9-2-2-2m3.7 3.7h-.8v3.6h.8c.6 0 1-.4 1-1v-1.6c0-.6-.5-1-1-1m-16.5-2.2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4.236l.582-2.3-2.305-.736a.6.6 0 0 1-.288-.944L9.9 8.5zm8.5 0h1a1 1 0 0 1 1 1v2l-2.6-.8zm2 6.9v-2.9l-3.1 3.9H14a1 1 0 0 0 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconBatteryChargingPercent80;